import React, { useContext } from 'react';
import { CoreContext } from './context/index.js';
import { w as withProviders } from './withProviders-l3mjYkR2.js';
import { selectCart } from './storeSelectors/cart.js';
import { S as ShoppingCartContentDrawer } from './ShoppingCartContentDrawer-MUZ0VwSX.js';
import { S as ShoppingCartDrawerSkeleton } from './ShoppingCartDrawerSkeleton-kCFrECX9.js';
import './utils/logToSlack.js';
import './animations--PMkOS0j.js';
import 'cookies-next';
import './currency-_kacFJHO.js';
import './language-BHHwgtQp.js';
import './payment-YC9H491Y.js';
import './index-tjIjLI8L.js';
import { useRouter } from 'next/router';
import 'notistack';
import 'next-i18next';
import usePageViewEvent from './hooks/usePageViewEvent.js';
import { selectCategory } from './storeSelectors/category.js';
import { selectProduct } from './storeSelectors/product.js';

const ShoppingCart = ({ isLoading = false, isYmalLoading = false }) => {
    const { useSelector } = useContext(CoreContext);
    const { route } = useRouter();
    const category = useSelector(selectCategory);
    const product = useSelector(selectProduct);
    const getCategory = () => {
        var _a, _b;
        if (route.includes('/c/')) {
            return (_a = category === null || category === void 0 ? void 0 : category.category) === null || _a === void 0 ? void 0 : _a.name_en.category_name;
        }
        if (route.includes('/p/')) {
            return (_b = product === null || product === void 0 ? void 0 : product.categories[0]) === null || _b === void 0 ? void 0 : _b.name_en.category_name;
        }
        return undefined;
    };
    usePageViewEvent({
        category: getCategory(),
        virtualPath: {
            name: 'mini basket',
            pathName: 'mini_basket',
        },
    });
    const cart = useSelector(selectCart);
    return (React.createElement("div", { className: "shopping-cart-container" }, isLoading ? (React.createElement(ShoppingCartDrawerSkeleton, null)) : (React.createElement(ShoppingCartContentDrawer, { cart: cart, isYmalLoading: isYmalLoading }))));
};
var ShoppingCartDrawer = withProviders(ShoppingCart, { translation: true, snackbar: true });

export { ShoppingCartDrawer as S };
//# sourceMappingURL=ShoppingCartDrawer-6X1Te1XE.js.map
